import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IPlanGestionMobilite } from '../../_models/PlanGestionMobilite';
import { BaseHubService } from './base-hub.service';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { MessageService } from '../local/message.service';
import { ConfigService } from '../local/config.service';
import { MainStoreState } from '../../_store/mainStoreState';
import { Store } from '@ngrx/store';
import { setPgmsAction } from '../../_store/PlanGestionMobiliteStore/plan-gestion-mobilite.store';
import { IBaseObject } from '../../_models/BaseObject';

@Injectable({
  providedIn: 'root',
})
export class PgmService extends BaseHubService<IPlanGestionMobilite> {
  constructor(
    private store: Store<MainStoreState>,
    http: HttpClient,
    messageService: MessageService,
    configService: ConfigService
  ) {
    super(
      'plans-gestion-mobilite',
      'hubs/pgmHub',
      'Plan gestion mobilité',
      http,
      messageService,
      configService
    );
  }

  retrieveFrom(
    idSegment: number,
    idTypeEs: number
  ): Observable<IPlanGestionMobilite | undefined> {
    return this.http
      .get<IPlanGestionMobilite>(this.baseUrl + `/${idSegment}/${idTypeEs}`)
      .pipe(catchError((error) => this.handleError(error)));
  }

  updatePgmMode(apply: boolean): Observable<boolean> {
    return this.http
      .post<boolean>(this.baseUrl + '/edition-mode', { apply })
      .pipe(
        catchError((error) => this.handleError(error)),
        map((res) => res !== undefined)
      );
  }

  uploadShapeFile(formdata: FormData) {
    return this.http.post(this.baseUrl + '/upload-shapes-files', formdata).pipe(
      catchError((error) => this.handleError(error)),
      map((res) => res !== undefined)
    );
  }

  refreshHubConnection(): Promise<void> {
    return this.start();
  }

  protected dispatchUpdateData(data: IBaseObject[]): void {
    this.store.dispatch(
      setPgmsAction({ payload: data as IPlanGestionMobilite[] })
    );
  }
}
